import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

const initialState = {
    location: [],
    stock: [],
    stockScroll: [],
    stockScrollMeta: {
        current_page: 1,
        last_page: 1,
        currentQuery: ''
    },
}

export default {
  namespaced: true,

  state: initialState,

  actions,

  getters,

  mutations
}
